import { createSlice } from '@reduxjs/toolkit';
import extraReducers, { roleExtraReducers } from 'src/redux/settings-users/extra-reducers';
import reducers, { roleReducers } from 'src/redux/settings-users/reducers';
import { rolesInitialState, settingsUsersInitialState } from 'src/redux/settings-users/types';

// ---- Users (people) ----

const settingsUsersSlice = createSlice({
  name: 'settings-users',
  initialState: settingsUsersInitialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const { upsertBlockOutWindow, removeBlockOutWindow } = settingsUsersSlice.actions;

export default settingsUsersSlice.reducer;

// ---- Roles (Settings → Users → User roles) ----

const rolesSlice = createSlice({
  name: 'settings-users/roles',
  initialState: rolesInitialState,
  reducers: roleReducers,
  extraReducers: (builder) => roleExtraReducers(builder),
});

export const { updateRoleData, deleteRoleFromRedux } = rolesSlice.actions;

export const roleManagementReducer = rolesSlice.reducer;
